<template>
  <v-dialog
    v-model="dialog"
    max-width="750px"
  >
    <template v-slot:activator="{ on }">
      <v-btn        
        icon
        v-on="on"
      >
        <v-icon
          v-if="viewOnly"
          color="primary"
        >
          mdi-eye
        </v-icon>

        <v-icon
          v-else
          color="primary"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      :title="title"
      text="Approve or reject promise"
      class="mb-0"
    >
      <form
        v-if="dialog"
      >
        <v-container>
          <v-row v-if="$hasPermissionTo(['view private promises'])">
            <v-col
              cols="12"
              class="pb-0"
            >
              <span class="font-weight-bold"> Promise Type </span>
              <v-radio-group                
                v-model="isPrivate"
                :disabled="viewOnly"
                row
              >
                <v-radio
                  class="mb-0"
                  label="Public"
                  :value="0"
                />
                <v-radio
                  class="mb-0"
                  label="Private"
                  :value="1"
                />
              </v-radio-group>
            </v-col>
          </v-row>
          
          <p class="mb-0 font-weight-bold">
            Condition:
          </p>

          <p
            class="mb-3 text-justify"
            style="white-space: pre-line;"
          >
            {{ promise.conditions }}
          </p>

          <br>
          <p class="mb-0 font-weight-bold">
            Promised:
          </p>

          <p
            class="text-success mb-3 text-justify" 
            style="white-space: pre-line;"
          >
            {{ promise.promise }}
          </p>

          <p class="mb-0 font-weight-bold">
            Document:
          </p>
          <v-span v-if="promise.documents.length>0">
            <v-chip
              v-for="document in promise.documents"
              :key="document.id"
              color="blue-grey lighten-3"
              small
              :href="document.file_url"
              target="_blank"
              class="mr-1"
            >
              <v-icon
                color="red"
                left
                small
              >
                mdi-file-pdf
              </v-icon>
              <span class="text-truncate"> {{ document.file_name }} </span>
            </v-chip>
          </v-span>
          <v-span v-else>
            N/A
          </v-span>

          <p
            class="text-danger mb-3 font-weight-bold" 
            style="white-space: pre-line;"
          >
            Promise Due Date: {{ promise.due_date }}
          </p>
          
          <div v-if="!viewOnly">
            <span class="font-weight-bold pt-6"> Action </span>
            <v-radio-group
              v-model="approvalStatus"
              v-validate="'required'"
              :error-messages="errors.collect('approval_status')"
              data-vv-name="approval_status"
              data-vv-as="Approval Action"
              class="mt-0"
              row
            >
              <v-radio
                class="mb-0 pt-0"
                label="Approve"
                :value="200"
              />
              <v-radio
                class="mb-0"
                label="Reject"
                :value="500"
              />
            </v-radio-group>
          </div>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!viewOnly"
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      promise: {
        type: Object,
        default: null,
      },  
      viewOnly: {
        type: Boolean,
        default: false,
      },    
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: null,
        isPrivate: 0,
        approvalStatus: null,
      }
    },
    computed: {
      title () {
        return `Viewing a promise with ${this.promise.employee.user.name}, 
        dated: ${this.$moment(this.promise.created_at, 'YYYY-MM-DD').format('D MMM YYYY')}` 
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$validator.reset()          
          this.$resetData()
        } else {
          this.isPrivate = this.promise.is_private
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.promises().update(this.promise.id, this.prepareFormData())
              .then((res) => {
                if (res.status === 200) {
                  this.$snack({ message: 'Promise Updated' })
                  this.$emit('updated')
                  this.dialog = false
                }
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      prepareFormData () {
        return {
          approval_status: this.approvalStatus,
          is_private: this.isPrivate,
        }
      },
      setProgressing (status) {
        this.progressing = status
      },      
    },
  }
</script>

<style lang='css' scoped>
</style>
